import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogTitle from '@material-ui/core/DialogTitle'
import React, { Component } from 'react'
import DialogButtonStyle from '../styles/DialogButtonStyle'

class ErrorDialog extends Component {
  render() {
    return (
      <Dialog open={this.props.error ? true : false}>
        <DialogTitle id="alert-dialog-title">{this.props.title}</DialogTitle>
        {this.props.content}
        <DialogButtonStyle>
          <DialogActions>
            <Button onClick={this.props.onCloseDialog} autoFocus>
              ZAMKNIJ
            </Button>
          </DialogActions>
        </DialogButtonStyle>
      </Dialog>
    )
  }
}

export default ErrorDialog
